export const ALERT_RED_COLOR = "#D0021B"
export const PROGRESS_STATUS_COLOR = "#50BBB8"
export const DRAFT_STATUS_COLOR = "#F1875A"

export const REPORT_ERROR_STATUS_COLOR = "#F1875A"
export const REPORT_COMPLETE_STATUS_COLOR = "#27B3AD"
export const REPORT_IN_PROGRESS_STATUS_COLOR = "#A7A7A3"

export const NO_MATCH_COLOR = "#000000"

export const DEMO_DATA_BACKGROUND_COLOR = "#BDBDBA"

export const CHANGE_OVER_TIME_POSITIVE_COLOR = "#27B3AD"
export const CHANGE_OVER_TIME_NEGATIVE_COLOR = "#F1875A"

export const QUESTION_EDIT_DISABLED_COLOR = "#D0D0D0"
